<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="sensorForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">
                  {{ office.city + ', ' + office.address }}
                </option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="relayBoardId">Relay Board</label>
              <select id="relayBoardId" class="form-control" formControlName="relayBoardId">
                <option></option>
                <option *ngFor="let relayBoard of relayBoards" [value]="relayBoard.id">
                  {{ relayBoard.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="sensorId">Sensor Id (1-8)</label>
              <input type="text" min="1" max="8" class="form-control" formControlName="sensorId"
                     id="sensorId" placeholder="Sensor Id">
            </div>
            <div class="col-md-6 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(sensorForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
